<button type="button" class="header-action-button" [class.header-action-link]="action?.isLink" (click)="onButtonClick($event)"
    [title]="action?.toolTip || action?.actionLabel || 'Refresh Data'">
    @if(isString(action?.iconClass)){
    <i [ngClass]="action?.iconClass"></i>
    }@else if(action?.isLink){
    <svg [lucideIcon]="action?.iconClass"></svg>
    }@else{
    <svg [lucideIcon]="action?.iconClass || refreshIcon()"></svg>
    }
    <span>{{action?.actionName || ''}}</span>
</button>
